import { Accounts } from "../model/Account"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import './css/NotificationBoard.css'
import useAuth from "../hook/useAuth"
import useDeepVinApi from "../hook/useDeepvinApi"
import { SignIn } from "../Signin"

export default function Dashboard() {
  const { auth } = useAuth()

  // if (data && data.AccountID === 1)
  //   return <Accounts />
  // else if (data && data.IsRoot)
  //   return <TeamDataTree />
  // else 
  //   return <MyVideos />
  // console.log("Dashboard auth: ", auth)
  if (Object.keys(auth).length === 0) {
    // If not authenticated, redirect to SignIn
    return <SignIn />
  } else {
    return (
      auth?.AccountID === 1
        ? <Accounts />
        : <NotificationBoard />
    )
  }
}

export const NotificationBoard = () => {
  const { auth } = useAuth()
  const api = useDeepVinApi()
  const [numPreload, setNumPreload] = useState(0)
  const [numMissingReport, setNumMissingReport] = useState(0)
  const [numActiveTask, setNumActiveTask] = useState(0)

  useEffect(() => {
    if (auth?.AccountID !== 1) {
      fetchPreload()
      fetchMissingReport()
      fetchTasks()
    }
  }, [])

  const fetchPreload = () => {
    api.get(`/api/preload/self/all`)
    .then(({data}) => setNumPreload(data.filter(video => !video.MarkDelete).length))
    .catch(error => console.error("API error: ", error))
  }

  const fetchTasks = () => {
    let category = auth.IsRoot ? "all" : (auth.IsAdmin ? "team" : "self")
    api.get(`/api/task/` + category)
    .then(({data}) => setNumActiveTask(data.filter(task => !task.Done).length))
    .catch(error => console.error("API error: ", error))
  }
  
  const fetchMissingReport= () => {
    api.get(`/api/video/self/missingreport`)
      .then(({data}) => setNumMissingReport(data ? data.length : 0))
      .catch(error => console.error("API error: ", error))
  }

  return (Object.keys(auth).length > 0 &&
    <div className="notificationboard">
      <h1>Dashboard</h1>
      <div className="notifications mb-4">
        <Link to={`/upload`}  className="link-no-underline">
          <NotificationCard type="Uploads without Case #" count={numPreload} />
        </Link>
      </div>
      <div className="notifications mb-4">
        <Link to={auth.IsRoot ? `/team/admin` : `/video/`}  className="link-no-underline">
          <NotificationCard type="Uploads missing Reports" count={numMissingReport} />
        </Link>
      </div>
      <div className="notifications mb-4">
        <Link to={`/task/`}  className="link-no-underline">
          <NotificationCard type="Tasks not Completed" count={numActiveTask} />
        </Link>
      </div>
    </div>
  )
}

export const NotificationCard = ({ type, count }) => {
  return (
    <div className="notification-card">
      <span className="notification-type">{type}</span>
      <span className="notification-count">{count}</span>
    </div>
  )
}
